// extracted by mini-css-extract-plugin
export var featuredProducts = "Products-module--featuredProducts--0JIwa";
export var inner = "Products-module--inner--+LuHV";
export var products = "Products-module--products--uS79U";
export var singleProduct = "Products-module--singleProduct--qbpFX";